// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 718 ? "e63997ca" : chunkId) + "." + {"718":"7c12abf916a4de24","910":"438f4e04b8224aab"}[chunkId] + ".js";
};